import { useMutation, useQueryClient } from '@tanstack/react-query'
import { vaultKeys } from '@/features/vault/use-vault'
import { removeDemoContent } from './demo-api'

export function useRemoveDemoContent() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => removeDemoContent(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: vaultKeys.files() })
      void qc.invalidateQueries({ queryKey: vaultKeys.ingestionJobs() })
    },
  })
}
